<template>
    <div>
        <!--      bulk-->
        <div v-if="userType == 'admin'">
            <div
                    v-for="item in SystemBulkReportSubMenu"
                    :key="item.index"
                    class="menu-item"
                    :class="{ active: item.route == currentRouteName }"
                    @click="changeRoute(item.route)"
            >
                <svg v-if="item.icon"
                     class="icon"
                     width="27px"
                     height="27px"
                     viewBox="0 0 30 30"
                     version="1.1"
                >
                    <title>{{item.text}}</title>
                    <path :d="item.icon" id="path-1" />
                </svg>
                <div :title="item.text">
                    <span v-if="item.featherIcon" :is="item.featherIcon" size="1.2x" class="custom-class"></span>
                </div>
                <span class="item-text">{{ item.text }}</span>
            </div>
        </div>

        <div v-if="userType == 'company_admin'">
            <div
                    v-for="item in CompanyBulkReportSubMenu"
                    :key="item.index"
                    class="menu-item"
                    :class="{ active: item.route == currentRouteName }"
                    @click="changeRoute(item.route)"
            >
                <svg v-if="item.icon"
                     class="icon"
                     width="27px"
                     height="27px"
                     viewBox="0 0 30 30"
                     version="1.1"
                >
                    <title>{{item.text}}</title>
                    <path :d="item.icon" id="path-1" />
                </svg>
                <div :title="item.text">
                    <span v-if="item.featherIcon" :is="item.featherIcon" size="1.2x" class="custom-class"></span>
                </div>
                <span class="item-text">{{ item.text }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { ListIcon, NavigationIcon,PieChartIcon,InboxIcon,LayoutIcon } from 'vue-feather-icons'

    export default {
        props: ["icon", "text", "route"],
        components: {
            ListIcon,
            NavigationIcon,
            PieChartIcon,
            InboxIcon,
            LayoutIcon

          
        },
        data: () => ({
            subMenu: null,
            userType: null,
            featherIcon: '',
            SystemBulkReportSubMenu: [
                {
                    route: "system-admin-bulk-report",
                    text: "Bulk Report",
                    icon: '',
                    featherIcon: 'layout-icon',
                },
                {
                    route: "system-admin-bulk-auto-substitute-report",
                    text: "Auto Substitute Bulk Report",
                    icon: '',
                    featherIcon: 'inbox-icon'
                },
                {
                    route: "system-admin-bulk-sms",
                    text: "Bulk Sms",
                    icon: '',
                    featherIcon: 'navigation-icon'
                },
            ],
            CompanyBulkReportSubMenu: [
                {
                    route: "company-admin-bulk-report",
                    text: "Bulk Report",
                    icon: '',
                    featherIcon: 'list-icon',
                },
                {
                    route: "company-admin-bulk-auto-substitute-report",
                    text: "Auto Substitute Bulk Report",
                    icon: '',
                    featherIcon: 'navigation-icon'
                },
                {
                    route: "company-admin-bulk-sms",
                    text: "Bulk Sms",
                    icon: '',
                    featherIcon: 'navigation-icon'
                },
            ],
        }),
        created() {
            this.userType = this.$store.getters.userType;
        },
        computed: {
            currentRouteName() {
                return this.$route.name;
            },
        },

        methods: {
            changeRoute(item) {
                this.$router.push({ name: item });
            },
        },
    };
</script>
<style lang="scss" scoped>
    .menu-item {
        display: flex;
        align-items: center;
        margin-left: 28px;
        margin-right: 10px;
        padding-left: 5px;
        border-radius: 3px;
        cursor: pointer;
        padding-top: .25rem;
        padding-bottom: .25rem;

        .custom-class{
            margin-right: .5rem;
            width: 25px;
            color: #1e1f20;

        }
        span:not(.custom-class) {
            font-size: 14px;
            color: #55616e;
            line-height: 20px;
        }
        svg:not(.custom-class) {
            fill: #55616e;
            margin-right: 5px;
        }
    }
    .active {
        background: #c7c7c7;
        span {
            color: white;
        }
    }
</style>